import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToSection } from 'utils/scrollToSection';

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname !== '/' || !hash) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      scrollToSection(hash.slice(1));
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [pathname, hash]);

  return null;
}

export default ScrollToHash;
